module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/footer/footer.component.scss
// module id = ./src/app/layout/footer/footer.component.scss
// module chunks = main